var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.teamName))])]),_c('div',{staticClass:"content"},_vm._l((_vm.list),function(item){return _c('WeeklyCard',{key:item.weeklyId,attrs:{"weekly":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }